import { typeBuilder } from 'base/shared/TypeHelper';

export default typeBuilder(['SET_LOCALE', 'SET_LOCALIZATION']);
